import React, { Component } from 'react'
import DnDPreview from 'react-dnd-preview'
import { PreviewManager } from 'dnd-multi-backend'
import Stage from './Stage'
import Task from './Task'

class PreviewComponent extends Component {
  constructor(props) {
    super(props)
    this.state = { enabled: false }
    PreviewManager.register(this)
  }

  componentWillUnmount() {
    PreviewManager.unregister(this)
  }

  backendChanged = backend => {
    this.setState({ enabled: backend.previewEnabled() })
  }

  render() {
    if (!this.state.enabled) {
      return null
    }
    return <DnDPreview {...this.props} />
  }
}

export default class Preview extends Component {
  generatePreview({ itemType, item, style }) {
    // console.log(itemType, item, style)

    // return (
    //   <div
    //     style={{
    //       ...style,
    //       backgroundColor: item.color,
    //       width: 100,
    //       height: 100,
    //       opacity: 0.7,
    //       border: `5px solid ${item.borderColor}`,
    //       borderRadius: 35,
    //     }}
    //   />
    // )

    const component = {
      stage: <Stage style={style} {...item} />,
      task: <Task style={style} {...item} />,
    }

    return component[itemType]
  }

  render() {
    return <PreviewComponent generator={this.generatePreview} />
  }
}
